import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import request, { Variables } from "graphql-request";

export function useGraphQLMutation<TResult, TVariables>(
  document: TypedDocumentNode<TResult, TVariables>,
  options: Omit<
    UseMutationOptions<TResult, unknown, TVariables, unknown>,
    "mutationFn"
  > = {}
): UseMutationResult<TResult, unknown, TVariables, unknown> {
  return useMutation({
    ...options,
    mutationFn: async (variables) => {
      return await request(
        process.env.GRAPHQL_API_URL as string,
        document,
        variables as Variables
      );
    },
  });
}
